export { Editor } from './editor'
export type { EditorProps } from './editor.types'
